import { createContext, useContext } from 'react';

import CONTACT_STATES from 'lib/common/constants/contactStates';

import TTask from 'lib/common/types/Task';

import { ISoftphoneModalOptionsProps } from '../SoftphoneModalContext';

export type TWaitForRelatedCallsConfirmation = {
  dialedNumber: string;
  isDialpadTransfer?: boolean;
  isSoftphone: boolean;
  openModal: (options?: ISoftphoneModalOptionsProps) => void;
  closeModal: () => void;
};

type TRelatedCallsContext = {
  state: {
    relatedId: string;
    isRelatingCall: boolean;
    lastCallWith: string;
    canRelateCall: boolean;
  };
  actions: {
    waitForRelatedCallsConfirmation: (arg0: TWaitForRelatedCallsConfirmation) => Promise<boolean>;
    resetRelatedCalls: () => void;
    setIsRelatingCall: (isRelatingCall: boolean) => void;
    handleRelatedCalls: ({
      changes,
      task,
    }: {
      changes: { status: keyof typeof CONTACT_STATES; eventTimestamp?: string };
      task: TTask;
    }) => void;
  };
};

const Context = createContext<TRelatedCallsContext>({
  state: {
    relatedId: '',
    isRelatingCall: false,
    lastCallWith: '',
    canRelateCall: false,
  },
  actions: {
    waitForRelatedCallsConfirmation: async () => true,
    setIsRelatingCall: () => {},
    handleRelatedCalls: () => {},
    resetRelatedCalls: () => {},
  },
});

export default Context;

export const useRelatedCallsContext = () => useContext(Context);
